<template>
  <div class="houseKeep">
    <el-container style="height: 100%;min-height:100vh;" direction="vertical">
      <el-header >
        <span style="font-size: 24px;">社区家政家教服务解决方案</span>
      </el-header>
      <el-main>
        <el-row>
          <span style="font-size: 20px;">1.应用场景</span>
          <p>社区家政家教服务主要针对城乡各个社区提供高品质的家政家教及医疗救助服务。公司提供一站式综合性服务，满足客户线上预约、线下服务的需求。如下图所示</p>
        </el-row>
        <el-row>
          <img width="600px" height="300px" src="@/assets/image/house_keep_service.png">
        </el-row>
        <el-row>
          <span style="font-size: 20px;">2.业务功能</span>
          <center>
            <el-table  :data="envData" ref="multipleTable" border stripe="true">
              <el-table-column type="index" label="序号" width="100"></el-table-column>
              <el-table-column prop="module" label="业务模块" width="200"></el-table-column>
              <el-table-column prop="desc" label="功能描述"></el-table-column>
            </el-table>
          </center>
        </el-row>
        <el-row>
          <span style="font-size: 20px;">3.解决问题</span>
          <center>
            <el-table  :data="envProblem" ref="multipleTable" border stripe="true">
              <el-table-column type="index" label="序号" width="100"></el-table-column>
              <el-table-column prop="desc" label="问题描述"></el-table-column>
            </el-table>
          </center>
        </el-row>
      </el-main>
    </el-container>
  </div>
</template>

<script>
export default {
  data () {
    return {
      envData: [{
        id: '1',
        module: '用户管理',
        desc: '平台提供用户（资源提供用户、社区用户、线下服务用户、第三方监管用户、线上运维用户等）注册、实名认证（身份证）、授权'
      }, {
        id: '2',
        module: '需求发布',
        desc: '社区用户用户根据自己的状况发布要求并选择相应的服务人员进行服务，并可跟踪自己发布需求的状态（发布、审核、交易、付款、服务评价等）'
      }, {
        id: '3',
        module: '服务审核',
        desc: '对社区用户的服务评价进行审核'
      }, {
        id: '4',
        module: '服务监督',
        desc: '社区服务接收政府及社区人员进行监督，防止非法服务损害社区居民利益'
      }, {
        id: '5',
        module: '服务推广站',
        desc: '对服务平台进行服务推广（包括线上和线下）'
      }],
      envProblem: [{
        id: '1',
        desc: '家政培训服务，提供一站式家政培训，从工具选择、家政操作、礼仪规范、卫生安全到服务完毕全过程。'
      }, {
        id: '2',
        desc: '新房装修及居家二次装修服务，装修器材选购服务等。'
      }, {
        id: '3',
        desc: '家教服务，以提供远程在线家教服务为主，线下家教为辅。'
      }, {
        id: '4',
        desc: '社区医疗救助服务，以提供远程在线医疗救助服务为主，线下医疗救助为辅。'
      }]
    }
  }
}
</script>

<style lang="less" scoped>
body {
  margin: 0px;
}
.houseKeep {
  margin: 0px;
  padding: 0px;
}
.el-row {
  margin-top: 10px;
  padding-top: 10px;
}
.el-table {
  margin-left: 50px;
  margin-right: 50px;
  width: 800px;
}
</style>
